<template>
  <div class="price">
    <slot name="right"></slot>
    <span v-show="showUnit">{{ $t('common.currency') }}</span>
    <span class="price-int">{{price | priceInt}}</span>
    <span class="price-point">{{ pricePoint(price) }}</span>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  props: {
    price: {
      type: Number,
      default: 0
    },
    showUnit: {
      type: Boolean,
      default: true
    },
    fixedNum: {
      type: Number,
      default: 2
    }
  },
  filters: {
    priceInt (value) {
      if (!value) {
        return 0
      }
      return String(value).split('.')[0]
    }
  },
  methods: {
    pricePoint (value) {
      if (!value) {
        return this.fixedNum === 2 ? '.00' : '.0000'
      }
      function padDecimal (num, digits) {
        // 转换为字符串
        var str = num.toString()
        // 分割整数部分和小数部分
        var parts = str.split('.')
        // 如果小数部分不足指定位数，补0
        while (parts[1] && parts[1].length < digits) {
          parts[1] += '0'
        }
        return `.${parts[1].substring(0, digits)}`
      }
      if (String(value).split('.')[1]) {
        return padDecimal(String(value), this.fixedNum)
      } else {
        return this.fixedNum === 2 ? '.00' : '.0000'
      }
    }
  }
}
</script>

<style>
</style>
